/**
 * FeaturedCollectionsCarousel - carousel of featured collection cards.
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 *
 * KNOWN VENDOR DEFECT (deliberately unfixed, renaming-only conversion): registers the
 * free identifier FeaturedCollectionsCarousel, which nothing defines - this module throws
 * a ReferenceError on load, on the published live theme too. See the defect ledger.
 */
window.componentService.registerComponent(
  "FeaturedCollectionsCarousel/FeaturedCollectionsCarousel.ts",
  { FeaturedCollectionsCarousel },
  void 0,
);
